import { withTranslation } from 'react-i18next';

import PriceEstimatorDialog from './PriceEstimatorDialog';

export default withTranslation()(PriceEstimatorDialog);
